import { bindOnceOn } from 'chimera/all/plugins/eventbus/events/bind'
import { emit } from './emit'

/**
 * Session start happens once per user session
 *
 * @type {string}
 */
export const sessionStartEvent = 'eb_sessionStart'

/**
 * Emit a session start event. Fires only once per session.
 */
export function emitSessionStartEvent() {
  emit(sessionStartEvent, {})
}

/**
 * @param {Function} callback
 */
export function onceOnSessionStartEvent(callback) {
  bindOnceOn(sessionStartEvent, callback)
}
